import { http } from '@/services/HttpService';
import { LoginRequest } from '@/models/request/LoginRequest';
import { LoginResponse } from '@/models/responses/LoginResponse';

export const login = async (request: LoginRequest): Promise<LoginResponse> => {
    return await http.post<LoginRequest, LoginResponse>(process.env.VUE_APP_API_LOGIN, request);
};